module.exports = __webpack_public_path__ + "static/images/spinner.ff62541037377858548e4e775dde5878.svg";